import type { CurrentRoleValue } from 'bundles/personalization-settings/hooks/useCurrentRoleEditor';
import type { SelectedRole } from 'bundles/personalization-settings/utils/desiredRolesV1';

const normalize = (name: string) => name.trim().toLowerCase();

/**
 * Whether to prompt the learner to add their current role to their desired
 * roles: they have a current role, it isn't already in desired roles (by
 * name -- the current-role and desired-roles catalogs use different id
 * namespaces, so name is the only comparable field), and there's room left
 * under the desired-roles limit.
 */
export const shouldPromptAddCurrentRoleToDesiredRoles = (
  currentRole: CurrentRoleValue,
  desiredRoles: readonly SelectedRole[],
  limit: number
): boolean => {
  if (!currentRole) return false;
  if (desiredRoles.length >= limit) return false;
  const normalizedCurrentRoleName = normalize(currentRole.name);
  return !desiredRoles.some((role) => normalize(role.name) === normalizedCurrentRoleName);
};
